export const CODE_FORBIDDEN = 403;
export const CODE_OK = 200;
export const CODE_UNAUTHORIZED = 401;
